import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  Badge,
  Bell,
  PlayCircle,
  Calendar,
  CreditCard,
  DollarSign,
  FileText,
  Filter,
  Gift,
  HeadphonesIcon,
  Instagram,
  LayoutDashboard,
  Link2,
  LogOut,
  Mail,
  MapPin,
  MessageCircle,
  MessageSquare,
  Receipt,
  RotateCcw,
  Server,
  Settings,
  Shield,
  Star,
  Store,
  UserCheck,
  UserPlus,
  Users,
  Target,
} from 'lucide-react';
import { useLoginQuery } from '@/hooks/queries/useLoginQuery';
import { useEffect, useState } from 'react';

interface MenuItem {
  icon: any;
  label: string;
  path: string;
}

export function Sidebar() {
  const location = useLocation();

  const menuItems: any[] = [
    { icon: Store, label: 'Merchants', path: '/merchants', boolean: true, permissions: ['merchants'] },
    { icon: UserPlus, label: 'Merchant Onboarding', path: '/merchant-onboarding', boolean: true, permissions: ['merchant_onboarding'] },
    { icon: MapPin, label: 'Locations', path: '/locations', boolean: true, permissions: ['locations'] },
    { icon: Gift, label: 'Free Trials', path: '/free-trials', boolean: true, permissions: ['free_trials'] },
    { icon: CreditCard, label: 'Subscriptions', path: '/subscriptions', permissions: ['subscriptions'] },
    { icon: Receipt, label: 'Transactions', path: '/transactions', boolean: true, permissions: ['transcations'] },
    { icon: DollarSign, label: 'Revenue', path: '/revenue', boolean: true, permissions: ['revenue'] },
    { icon: Star, label: 'Reviews', path: '/reviews', boolean: true, permissions: ['reviews'] },
    { icon: MessageSquare, label: 'Review Platforms', path: '/review-platforms', permissions: ['review_platforms'] },
    { icon: Instagram, label: 'Instagram', path: '/instagram', boolean: true, permissions: ['instagram'] },
    { icon: UserCheck, label: 'Visitors', path: '/visitors', boolean: true, permissions: ['visitors'] },
    { icon: MessageSquare, label: 'SMS Analytics', path: '/sms-analytics', permissions: ['sms_analytics'] },
    { icon: FileText, label: 'SMS Templates', path: '/sms-templates', boolean: true, permissions: ['sms_templates'] },
    { icon: Bell, label: 'Communications', path: '/communications', boolean: true },
    { icon: Calendar, label: 'SMS Schedules', path: '/sms-schedules', boolean: true, permissions: ['sms_schedules'] },
    { icon: FileText, label: 'Testing', path: '/testing', boolean: true, permissions: ['testing'] },
    { icon: Shield, label: 'Fraud Monitoring', path: '/fraud-monitoring', boolean: true, permissions: ['fraud_monitoring'] },
    { icon: Link2, label: 'Bussines Referrals', path: '/referrals', boolean: true },
    { icon: HeadphonesIcon, label: 'Support', path: '/support', boolean: true, permissions: ['support'] },
    { icon: Mail, label: 'Enquiries', path: '/enquiries', boolean: true },
    { icon: Users, label: 'Team', path: '/team', boolean: true, permissions: ['team'] },
    { icon: UserCheck, label: 'Leads', path: '/funnels', boolean: true },
    { icon: Target, label: 'Target Leads', path: '/target-leads', boolean: true },
    { icon: PlayCircle, label: 'Demos Checked', path: '/demos-checked', boolean: true },
    { icon: Filter, label: 'Signup Funnel', path: '/leads/funnel', boolean: true },
    { icon: Shield, label: 'Staff Access', path: '/staff-access', boolean: true },
    { icon: Bell, label: 'In-App Messages', path: '/in-app-messages', boolean: true },
    { icon: Settings, label: 'Settings', path: '/settings', boolean: true, permissions: ['settings'] },
    // { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard', boolean: true },
    { icon: Server, label: 'Services', path: '/services', boolean: true },

    // { icon: MessageCircle, label: 'Testimonials', path: '/testimonials', boolean: true },
    { icon: RotateCcw, label: 'Refunds', path: '/refunds', boolean: true },
  ];
  const { data: loginUser } = useLoginQuery();
  const [filteredMenuItems, setFilteredMenuItems] = useState(menuItems);
  useEffect(() => {
    if (!loginUser) return;
    const userPermissions: string[] = Array.isArray((loginUser as any)?.permissions)
      ? (loginUser as any).permissions
      : [];

    setFilteredMenuItems(
      menuItems.filter((item) => {
        const requiredPermissions: string[] | undefined = Array.isArray((item as any)?.permissions)
          ? (item as any).permissions
          : undefined;
        if (!requiredPermissions || requiredPermissions.length === 0) return true;
        return requiredPermissions.some((permission) => userPermissions.includes(permission));
      })
    );
  }, [loginUser]);

  return (
    <div className="w-64 bg-card border-r h-screen flex flex-col">
      <div className="p-6">
        <h1 className="text-2xl font-bold">LocalFirst</h1>
      </div>

      <nav className="flex-1 overflow-y-auto px-4">
        {filteredMenuItems.map((item) => (
          <Link key={item.path} to={item.path}>
            <Button
              variant="ghost"
              className={cn(
                'w-full justify-start mb-1',
                location.pathname === item.path && 'bg-accent text-accent-foreground',
                item.boolean === false && 'bg-gray-200 font-bold text-gray-900 hover:bg-gray-200'
              )}
            >
              <item.icon className="w-4 h-4 mr-3" />
              {item.label}

            </Button>
          </Link>
        ))}
      </nav>

      {/* <div className="p-4 border-t">
        <Link to="/logout">
          <Button variant="ghost" className="w-full justify-start">
            <LogOut className="w-4 h-4 mr-3" />
            Logout
          </Button>
        </Link>
      </div> */}
    </div>
  );
}
